module.exports = __webpack_public_path__ + "static/media/complianceActive.d6123636.svg";